__turbopack_context__.v({
  "calendar-container": "CoreEventDetails-module-scss-module__ROTkZq__calendar-container",
  "calendar-cta": "CoreEventDetails-module-scss-module__ROTkZq__calendar-cta",
  "detail-item": "CoreEventDetails-module-scss-module__ROTkZq__detail-item",
  "details": "CoreEventDetails-module-scss-module__ROTkZq__details",
  "header": "CoreEventDetails-module-scss-module__ROTkZq__header",
  "main": "CoreEventDetails-module-scss-module__ROTkZq__main",
  "subheader": "CoreEventDetails-module-scss-module__ROTkZq__subheader",
});
